import { render, staticRenderFns } from "./BrandingCategories.vue?vue&type=template&id=0df5805e&scoped=true"
import script from "./BrandingCategories.vue?vue&type=script&lang=js"
export * from "./BrandingCategories.vue?vue&type=script&lang=js"
import style0 from "./BrandingCategories.vue?vue&type=style&index=0&id=0df5805e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df5805e",
  null
  
)

export default component.exports